module.exports = __webpack_public_path__ + "img/placeholder.779b31af.jpg";